export const ROUTES = {
  LOGIN: '/membership/login',
  SIGNUP: '/membership/signup',
  FORGOT_PASSWORD: '/membership/forgotPassword',
  DELETE_USER: '/membership/deleteUser',
  WORKSPACE: '/onboarding/workspace',
  MOBILEONBOARDING: '/onboarding/mobileOnboarding',
  ONBOARDING_STEP2: '/onboarding/step2',
  WELCOME: '/welcome',
  SELECT_WORKSPACE: '/select-workspace',
  MEMBERSHIP_INVITATION: '/membership/invitation/:id',
  RESET_PASSWORD: '/membership/reset-password',
  // With Navbar
  WORKSPACE_REDIRECT: '/:workspace_id',

  MYTASK: '/my-tasks',
  NAVBARMESSAGE: '/messages',
  NAVBARMESSAGE_DETAILS_MOBILE: '/messages/details',
  SNAP: '/snap',
  INVOICES: '/invoices',
  ADD_NEW_INVOICES: '/invoices/create-tracked-invoice',
  ADD_NEW_INVOICES_2: '/invoices/create-blank-invoice',
  EDIT_INVOICES: '/invoices/update/:invoice_id',
  ALL_PROJECT: '/projects',
  CREATE_PROJECT: '/projects/create',
  CREATE_PROJECT_STEP2: '/projects/create/step2',
  PERSONAL_SETTING: '/settings/personal',
  PASSWORD_SETTING: '/settings/password',
  EMAIL_SETTING: '/settings/email',
  NOTIFICATION_SETTING: '/settings/notification',
  SECURITY_ACCESS_SETTING: '/settings/security-access',
  GENERAL_SETTING: '/settings/general',
  AI_AGENTS_SETTING: '/settings/ai-agents',
  AI_AGENTS_SETTING_DETAILS: '/settings/ai-agents/details/:id',
  TEMPLATES_SETTING: '/settings/templates',
  TEMPLATES_SETTING_DETAILS: '/settings/templates/:id',
  PAYMENT_SETTING: '/settings/payment',
  PAYMENT_STRIPE_SETTING: '/settings/payment/stripe',
  FIGMA_CONNECT_REDIRECT: '/integration/figma/fallback',
  SUBSCRIPTION_SETTING: '/settings/subscription',
  APPS_SETTING: '/settings/apps',
  API_SETTING: '/settings/apikey',
  INTEGRATIONS_SETTING: '/settings/integrations',
  TEAM_SETTING: '/settings/teams',
  INVOICE_SETTING: '/settings/invoice',
  REFEREARN_SETTING: '/settings/referEarn',
  TEAMCAMP_AI: '/settings/teamcamp-ai',
  USAGE_SETTING: '/settings/usage',
  INBOX: '/',
  CUSTOMER: '/customer',
  CUSTOMERDETAIL: '/customer/customerDetail',
  TIMETRACKING: '/timeTracking',
  REPORT: '/report',
  REPORT_PAYMENTS: '/report/payments',
  REPORT_UNINVOICED: '/report/uninvoiced',
  REPORT_INVOICE: '/report/report_invoice',
  REPORT_PROJECTS: '/report/projects',
  REPORT_WORKLOAD: '/report/workload',
  REPORT_TASK: '/report/task',
  REPORT_TEAM_TIMELINE: '/report/team_timeline',
  REPORT_PROJECTS_TIMELINE: '/report/project_timeline',
  ARCHIVE_PROJECT: '/projects/archived',
  REPORT_TIMES: '/report/times',
  RECURRINGTASK: '/recurring-tasks',
  MY_TIMELOG: '/timeTracking/myTimelog',
  SEARCH: '/search',
  SETTING: '/setting',
  HOME: '/home',
  TASK_TEMPLATES_SETTING_DETAILS: '/settings/template/taskTemplateDetails/:id',
  INTEGRATIONS_DETAILS: '/settings/integration/github',
  GITHUB_CALLBACK: '/settings/integration/github/callback',
  VERCEL_INTEGRATION_DETAILS: '/settings/integration/vercel',
  SENTRY_CALLBACK: '/settings/integration/sentry/callback',
  VIEWS: '/views',
  VIEW_ROUTE: '/views/:viewId',
  VIEWS_NEW: '/views/new-view',
  VERCEL_AUTH: '/vercel/auth',
  ALL_ACTIVITIES: '/projects/details/:id/activities',
  GOOGLE_CONNECT_REDIRECT: '/signin/google',
  PROJECT_DETAILS: '/projects/details/:id',
  PROJECT_TASKS: '/projects/details/:id/tasks',
  PROJECT_FILES: '/projects/details/:id/files',
  PROJECT_FILE_VIEW: '/projects/details/:id/files/file-view/:name',
  PROJECT_MESSAGES: '/projects/details/:id/messages',
  PROJECT_OVERVIEW: '/projects/details/:id/overview',
  PROJECT_MILESTONE: '/projects/details/:id/milestone',
  PROJECT_DOCS: '/projects/files/:id/docs/:docid',
  PROJECT_SETTING: '/projects/details/:id/setting',
  TASK_DETAILS: '/projects/details/:id/tasks/details/:taskId',
  MEMBER_OVERVIEW: '/members/:id/overview',
  MEMBER_TASKS: '/members/:id/tasks',
  INVOICE_DETAILS: '/invoices/view/:id',
  CUSTOMER_DETAILS: '/customer/:id',
  PROJECT_TAB: '/projects/details/:id/:tab'
};
